module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat6-46b22e3aeca6d965d399a5496e5208fd.svg";